const REQUIRED_ENV_VARS = [
    'REACT_APP_API_URL',
    'REACT_APP_API_CONTACT_FORM_TOKEN',
    'REACT_APP_API_READ_TOKEN',
]

export const validateEnvVariables = (): boolean => {
    return REQUIRED_ENV_VARS.every((envVar) => !!process.env[envVar])
}
